<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row>
        <v-col cols="12" class="pl-12">
          <span class="status pr-12 display-4 ml-12 blue-grey--text">403</span>
          <span class="pl-12 display-1">Access Denied</span>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'view-access-denied'
}
</script>

<style scoped>
.status { border-right: 1px solid  #CCC }
</style>
